import { ApiError } from '@libs/types';

export const isError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  if ('message' in error || 'error' in error || 'statusCode' in error) {
    return true;
  }

  if ('message' in error && 'errors' in error) {
    const errorObj = error as { errors: unknown[] };
    if (Array.isArray(errorObj.errors)) {
      return errorObj.errors.every(
        (err) =>
          typeof err === 'object' &&
          err !== null &&
          'property' in err &&
          'errors' in err &&
          Array.isArray((err as { errors: unknown[] }).errors)
      );
    }
  }

  if ('error' in error) {
    return true;
  }

  return false;
};

export const getErrors = (error: unknown): ApiError[] => {
  if (!error || typeof error !== 'object') {
    return [];
  }
  
  if ('error' in error) {
    const errorData = error.error as {
      data?: { 
        errors?: ApiError[];
        message?: string;
      };
    };

    if (errorData?.data?.errors) {
      return errorData.data.errors;
    }

    if (errorData?.data?.message) {
      return [{
        property: 'unknown',
        errors: [errorData.data.message]
      }];
    }
  }

  if ('message' in error) {
    return [
      {
        property: 'unknown',
        errors: [error.message],
      },
    ] as ApiError[];
  }

  return [];
};

export const getErrorsAsString = (error: unknown): string => {
  return getErrors(error).map((error) => error.errors.join(', ')).join('\n')
};

export const getInputErrors = (
  property: string,
  errors: ApiError[]
): string => {
  if (!errors) {
    return '';
  }

  const error = errors.find((error) => error.property === property)?.errors;

  return error?.[0] ?? '';
};
